import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import { EmojiPicker } from "react-emoji-search";
import { Dropdown, Button, Icon } from "~/components-shared";
const StyledDropdownList = styled(Dropdown.List)`
  width: 320px;
  height: 300px;

  .items-center {
    padding: 0 10px;

    button {
      padding-left: initial !important;
      padding-right: initial !important;
    }
  }
`;
const EmojiDropdown = _ref => {
  let {
    onChange = () => false,
    direction = "bottomRight",
    s,
    ...rest
  } = _ref;
  const theme = useTheme();
  const customHandler = toggle => /*#__PURE__*/React.createElement(Button, {
    color: "primaryTransparent",
    outline: false,
    onClick: toggle,
    s: {
      p: 1
    },
    fontSize: 6,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "emoji",
    display: "block",
    color: theme.colors.text.secondary
  }));
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    direction: direction,
    customHandler: customHandler
  }, rest), _ref2 => {
    let {
      isOpen,
      onItemClick
    } = _ref2;
    return /*#__PURE__*/React.createElement(StyledDropdownList, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(EmojiPicker, {
      emojiVersion: 12.0,
      onEmojiClick: emoji => {
        onItemClick();
        onChange(emoji);
      },
      tabsVariant: "fullWidth",
      styles: {
        backgroundColor: theme.colors.background.primary,
        indicatorColor: theme.colors.primary.main,
        fontColor: theme.colors.text.secondary,
        searchBackgroundColor: theme.colors.background.dark,
        tabsFontColor: theme.colors.primary.main,
        searchFontColor: theme.colors.text.primary,
        skinTonePickerBackgroundColor: theme.colors.background.primary
      }
    }));
  });
};
export default EmojiDropdown;